
export default {
  state: {},
  reducers: {

  }
};
